export const AdminModalTypePrompts: Record<string, string> = {
  approve: "Please provide a reason for approving the user(s)",
  remove: "Please provide a reason for removing the user(s)",
  decline: "Please provide a reason for declining the user(s)",
  reactivate: "Please provide a reason for reactivating the user(s)",
  approved: "Please provide a reason for deprovisioning the user(s)",
  rejected: "Please provide a reason for rejecting the user(s)",
}
